import { render, staticRenderFns } from "./BalanceView.vue?vue&type=template&id=7629745d&scoped=true&"
import script from "./BalanceView.vue?vue&type=script&lang=js&"
export * from "./BalanceView.vue?vue&type=script&lang=js&"
import style0 from "./BalanceView.vue?vue&type=style&index=0&id=7629745d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7629745d",
  null
  
)

export default component.exports